import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { AddCircleOutlineRounded, Delete } from "@mui/icons-material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { IconButton, TextField } from "@mui/material";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import { CACHE_KEY } from "../constant/cache-key";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";

export default function AccountTypes({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [OGdata, setOGData] = useState([]);
  const [itemEditible, setItemEditible] = useState({});
  const [subItemEditible, setSubItemEditible] = useState({});
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState([]);
  const [inputV, setInputV] = useState([]);
  const [subOpenAdd, setSubOpenAdd] = useState([]);
  const [subInputV, setSubInputV] = useState([]);
  const [openSubMenuIdx, setOpenSubMenuIdx] = useState(null);
  const subMenuRefs = useRef([]);

  const toggleSubMenu = (idx) => {
    setOpenSubMenuIdx(openSubMenuIdx === idx ? null : idx);
  };

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      menu: [],
      language: item.attributes.language,
    }));
    setData(docs);
    setOGData(docs);
    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);
    let subOpenDocs = [];
    langs.map(() => {
      subOpenDocs.push({ open: false });
    });
    setSubOpenAdd(subOpenDocs);
    let inputVDocs = [];
    langs.map(() => {
      inputVDocs.push({
        title: "",
        btn1T: "",
        btn1L: "",
        btn2T: "",
        btn2L: "",
        desc: "",
      });
    });
    setInputV(inputVDocs);
    let subInputVDocs = [];
    langs.map(() => {
      subInputVDocs.push({ title: "", description: "" });
    });
    setSubInputV(subInputVDocs);

    async function getData() {
      await fetch(`${API}/account-type`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.accountTypesData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });

        setOGData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const onDragEnd = (result, index) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    const items = Array.from(data[index].menu);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    setData((prevData) =>
      prevData.map((item, idx) => (idx === index ? { ...item, menu: items } : item))
    );
  };

  const onSubDragEnd = (result, index, idx) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    // Create a copy of the nested array to work with
    const nestedMenuItems = Array.from(data[index].menu);
    const items = Array.from(nestedMenuItems[idx].dropDownItems);

    // Remove the item from the source index
    const [reorderedItem] = items.splice(source.index, 1);

    // Insert the item at the destination index
    items.splice(destination.index, 0, reorderedItem);

    // Update the nested structure in the state
    setData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
            ...item,
            menu: nestedMenuItems.map((nestedItem, j) =>
              j === idx ? { ...nestedItem, dropDownItems: items } : nestedItem
            ),
          }
          : item
      )
    );
  };

  const addNewMenuItem = (index) => {
    let tempData = data;

    tempData[index]?.menu.push({
      title: inputV[index]?.title.charAt(0).toUpperCase() + inputV[index]?.title.slice(1),
      btn1T: inputV[index]?.btn1T,
      btn1L: inputV[index]?.btn1L,
      btn2T: inputV[index]?.btn2T,
      btn2L: inputV[index]?.btn2L,
      desc: inputV[index]?.desc,
      dropDownItems: [],
    });

    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setData(tempData);
        setSuccess(true);
        setInputV(
          inputV.map((item, idx) => {
            if (idx === index) {
              return {
                ...item,
                title: "",
                btn1T: "",
                btn1L: "",
                btn2T: "",
                btn2L: "",
                desc: "",
              };
            } else {
              return item;
            }
          })
        );
        setOpenAdd([
          ...openAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
      } else {
        setFail(true);
      }
    });
  };

  const deleteMenuItem = (index, idx) => {
    let tempData = data;
    let filteredData = tempData[index]?.menu.filter((item, i) => i !== idx);

    tempData[index] = {
      ...tempData[index],
      menu: filteredData,
    };

    setData(tempData);

    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleInputChange = (index, field, value) => {
    setInputV((prevState) =>
      prevState.map((item, idx) => (idx === index ? { ...item, [field]: value } : item))
    );
  };

  const addNewSubMenuItem = (index, idx) => {
    let tempData = data;

    tempData[index]?.menu[idx]?.dropDownItems?.push({
      title: subInputV[index]?.title.charAt(0).toUpperCase() + subInputV[index]?.title.slice(1),
      description: subInputV[index]?.description,
    });

    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setData(tempData);
        setSuccess(true);
        setSubInputV([
          ...subInputV.map((item, idx) => {
            if (idx === index) {
              return {
                ...item,
                title: "",
                description: "",
              };
            } else {
              return item;
            }
          }),
        ]);
        setSubOpenAdd([
          ...subOpenAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
      } else {
        setFail(true);
      }
    });
  };

  const deleteSubMenuItem = (index, idx, ndx) => {
    const updatedData = [...data];

    if (
      updatedData[index] &&
      updatedData[index].menu &&
      updatedData[index].menu[idx] &&
      updatedData[index].menu[idx].dropDownItems
    ) {
      updatedData[index].menu[idx].dropDownItems = updatedData[index].menu[
        idx
      ].dropDownItems.filter((item, i) => i !== ndx);

      setData(updatedData);

      fetch(`${API}/account-type`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { accountTypesData: updatedData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setSuccess(true);
        } else {
          setFail(true);
        }
      });
    }
  };

  const editMenuItem = (item, index, idx) => {
    setData(OGdata);
    setSubItemEditible({});

    setOpenAdd([
      ...openAdd.map((item, indx) => {
        if (indx === index) {
          return { ...item, open: true };
        } else {
          return item;
        }
      }),
    ]);

    setItemEditible({ index, idx });

    setInputV([
      ...inputV.map((itm, idx) => {
        if (idx === index) {
          return {
            ...itm,
            title: item.title,
            desc: item.desc,
            btn1T: item.btn1T,
            btn1L: item.btn1L,
            btn2T: item.btn2T,
            btn2L: item.btn2L,
          };
        } else {
          return itm;
        }
      }),
    ]);
  };

  const editSubMenuItem = (index, idx, ndx) => {
    setData(OGdata);
    setItemEditible({});
    const item = {
      index,
      idx,
      ndx,
    };

    if (
      subItemEditible.index === index &&
      subItemEditible.idx === idx &&
      subItemEditible.ndx === ndx
    ) {
      setSubItemEditible({});
    } else {
      setSubItemEditible(item);
    }
  };

  const doneeditingMenuSubItem = (index, idx, ndx) => {
    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: data },
      }),
    }).then((res) => {
      if (res.ok) {
        setOGData(data);
        toast("Updated Successfully", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success",
        });
      }
    });

    setSubItemEditible({});
  };

  const updateItem = () => {
    const { index, idx } = itemEditible;

    // Make a shallow copy of the data array
    const updatedData = [...data];

    // Make a shallow copy of the specific item to be updated
    const updatedItem = {
      ...updatedData[index].menu[idx],
      ...inputV[index], // Spread the inputV to update the specific fields
    };

    // Update the specific item in the menu array
    updatedData[index].menu[idx] = updatedItem;

    // Set the updated data back to the state
    setData(updatedData);

    setOpenAdd([
      ...openAdd.map((item, idx) => {
        if (idx === index) {
          return {
            ...item,
            open: false,
          };
        } else {
          return item;
        }
      }),
    ]);

    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { accountTypesData: updatedData },
      }),
    }).then((res) => {
      if (res.ok) {
        toast("Updated Successfully", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success",
        });
      }
    });

    const clearedInputV = inputV.map((item) => ({
      title: "",
      btn1T: "",
      btn1L: "",
      btn2T: "",
      btn2L: "",
      desc: "",
    }));

    setInputV(clearedInputV);

    setItemEditible({});
  };

  return (
    <TabContext value={value}>

      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.accountType,
            CACHE_KEY.startupConfigs,

          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Account Types Settings</h3>



        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      pointerEvents: user.perms[7].edit ? null : "none",
                    }}>
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, index)}>
                      <Droppable droppableId={`menu-${index}`} key={`droppable-${index}`}>
                        {(provided) => (
                          <ul
                            style={{ padding: 0, marginTop: 0, width: "40%" }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {data[index]?.menu.map((item, idx) => (
                              <Draggable
                                key={`item-key-${idx + 40 * 70}`}
                                draggableId={`item-key-${idx + 40 * 8}`}
                                index={idx}>
                                {(provided) => (
                                  <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}>
                                    <div className="menu-b-i">
                                      <DragIndicatorIcon style={{ color: "#777" }} />

                                      <p
                                        style={{
                                          margin: 0,
                                          fontSize: 16,
                                          marginBottom: -3,
                                          fontWeight: "500",
                                        }}>
                                        {item.title}
                                      </p>

                                      <div className="delete-menu-item" style={{ right: 40 }}>
                                        <IconButton
                                          onClick={() => editMenuItem(item, index, idx)}
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "#0265d2",
                                            },
                                            transition: "0.3s",
                                          }}>
                                          <EditIcon fontSize="small" />
                                        </IconButton>

                                        <IconButton
                                          onClick={() => deleteMenuItem(index, idx)}
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "red",
                                            },
                                            transition: "0.3s",
                                          }}>
                                          <Delete fontSize="small" />
                                        </IconButton>
                                      </div>
                                      <div className="delete-menu-item">
                                        <IconButton
                                          ref={(el) => (subMenuRefs.current[idx] = el)}
                                          onClick={() => {
                                            toggleSubMenu(idx);
                                            setSubItemEditible({});
                                          }}
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "var(--link)",
                                            },
                                            transition: "0.3s",
                                          }}>
                                          <ArrowForwardIosIcon fontSize="small" />
                                        </IconButton>

                                        <div
                                          className="sub-menu"
                                          ref={(el) => (subMenuRefs.current[idx + 30] = el)}
                                          style={{
                                            visibility:
                                              openSubMenuIdx === idx ? "visible" : "hidden",
                                            opacity: openSubMenuIdx === idx ? 1 : 0,
                                            width: openSubMenuIdx === idx ? 430 : 0,
                                          }}>
                                          <DragDropContext
                                            onDragEnd={(result) =>
                                              onSubDragEnd(result, index, idx)
                                            }>
                                            <Droppable
                                              droppableId={`menu-${index + 60 * 8}`}
                                              key={`droppable-${index + 78 * 39}`}>
                                              {(provided) => (
                                                <ul
                                                  style={{
                                                    padding: 0,
                                                    marginTop: 0,
                                                    width: "90%",
                                                  }}
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}>
                                                  {data[index]?.menu[idx].dropDownItems?.map(
                                                    (item, ndx) => (
                                                      <Draggable
                                                        key={`item-key-${ndx + 403 * 70}`}
                                                        draggableId={`item-key-${ndx + 4013 * 8}`}
                                                        index={ndx}>
                                                        {(provided) => (
                                                          <li
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}>
                                                            <div
                                                              className="menu-b-i"
                                                              style={{
                                                                height:
                                                                  subItemEditible.index == index &&
                                                                    subItemEditible.idx == idx &&
                                                                    subItemEditible.ndx == ndx
                                                                    ? 130
                                                                    : 50,
                                                              }}>
                                                              <DragIndicatorIcon
                                                                style={{
                                                                  color: "#777",
                                                                }}
                                                              />

                                                              <div>
                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx ? (
                                                                  <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    sx={{
                                                                      mb: 1,
                                                                    }}
                                                                    inputProps={{
                                                                      style: {
                                                                        fontSize: 14,
                                                                      },
                                                                    }}
                                                                    value={item.title || ""}
                                                                    onChange={(e) =>
                                                                      setData(
                                                                        data.map(
                                                                          (
                                                                            outerItem,
                                                                            outerIndex
                                                                          ) => {
                                                                            if (
                                                                              outerIndex === index
                                                                            ) {
                                                                              return {
                                                                                ...outerItem,
                                                                                menu: outerItem.menu.map(
                                                                                  (
                                                                                    innerItem,
                                                                                    innerIndex
                                                                                  ) => {
                                                                                    if (
                                                                                      innerIndex ===
                                                                                      idx
                                                                                    ) {
                                                                                      return {
                                                                                        ...innerItem,
                                                                                        dropDownItems:
                                                                                          innerItem.dropDownItems.map(
                                                                                            (
                                                                                              nestedItem,
                                                                                              nestedIndex
                                                                                            ) => {
                                                                                              if (
                                                                                                nestedIndex ===
                                                                                                ndx
                                                                                              ) {
                                                                                                return {
                                                                                                  ...nestedItem,
                                                                                                  title:
                                                                                                    e
                                                                                                      .target
                                                                                                      .value,
                                                                                                };
                                                                                              } else {
                                                                                                return nestedItem;
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                      };
                                                                                    } else {
                                                                                      return innerItem;
                                                                                    }
                                                                                  }
                                                                                ),
                                                                              };
                                                                            } else {
                                                                              return outerItem;
                                                                            }
                                                                          }
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <p
                                                                    style={{
                                                                      margin: 0,
                                                                      fontSize: 14,
                                                                      marginBottom: -3,
                                                                      fontWeight: "500",
                                                                    }}>
                                                                    {item.title}
                                                                  </p>
                                                                )}
                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx ? (
                                                                  <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    inputProps={{
                                                                      style: {
                                                                        fontSize: 14,
                                                                      },
                                                                    }}
                                                                    value={item.description || ""}
                                                                    onChange={(e) =>
                                                                      setData(
                                                                        data.map(
                                                                          (
                                                                            outerItem,
                                                                            outerIndex
                                                                          ) => {
                                                                            if (
                                                                              outerIndex === index
                                                                            ) {
                                                                              return {
                                                                                ...outerItem,
                                                                                menu: outerItem.menu.map(
                                                                                  (
                                                                                    innerItem,
                                                                                    innerIndex
                                                                                  ) => {
                                                                                    if (
                                                                                      innerIndex ===
                                                                                      idx
                                                                                    ) {
                                                                                      return {
                                                                                        ...innerItem,
                                                                                        dropDownItems:
                                                                                          innerItem.dropDownItems.map(
                                                                                            (
                                                                                              nestedItem,
                                                                                              nestedIndex
                                                                                            ) => {
                                                                                              if (
                                                                                                nestedIndex ===
                                                                                                ndx
                                                                                              ) {
                                                                                                return {
                                                                                                  ...nestedItem,
                                                                                                  description:
                                                                                                    e
                                                                                                      .target
                                                                                                      .value,
                                                                                                };
                                                                                              } else {
                                                                                                return nestedItem;
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                      };
                                                                                    } else {
                                                                                      return innerItem;
                                                                                    }
                                                                                  }
                                                                                ),
                                                                              };
                                                                            } else {
                                                                              return outerItem;
                                                                            }
                                                                          }
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <p
                                                                    style={{
                                                                      margin: 0,
                                                                      fontSize: 12,
                                                                      marginBottom: -3,
                                                                      color: "gray",
                                                                    }}>
                                                                    {item.description}
                                                                  </p>
                                                                )}
                                                              </div>
                                                              <div
                                                                className="delete-menu-item"
                                                                style={{
                                                                  right: 10,
                                                                }}>
                                                                {subItemEditible.index == index &&
                                                                  subItemEditible.idx == idx &&
                                                                  subItemEditible.ndx == ndx ? (
                                                                  <>
                                                                    <IconButton
                                                                      onClick={() =>
                                                                        doneeditingMenuSubItem(
                                                                          index,
                                                                          idx,
                                                                          ndx
                                                                        )
                                                                      }
                                                                      sx={{
                                                                        color: "green",
                                                                      }}>
                                                                      <DoneIcon fontSize="medium" />
                                                                    </IconButton>
                                                                  </>
                                                                ) : (
                                                                  <IconButton
                                                                    onClick={() =>
                                                                      editSubMenuItem(
                                                                        index,
                                                                        idx,
                                                                        ndx
                                                                      )
                                                                    }
                                                                    sx={{
                                                                      color: "grey",
                                                                      "&:hover": {
                                                                        color: "#0265d2",
                                                                      },
                                                                      transition: "0.3s",
                                                                    }}>
                                                                    <EditIcon fontSize="small" />
                                                                  </IconButton>
                                                                )}
                                                                <IconButton
                                                                  onClick={() =>
                                                                    deleteSubMenuItem(
                                                                      index,
                                                                      idx,
                                                                      ndx
                                                                    )
                                                                  }
                                                                  sx={{
                                                                    color: "grey",
                                                                    "&:hover": {
                                                                      color: "red",
                                                                    },
                                                                    transition: "0.3s",
                                                                  }}>
                                                                  <Delete fontSize="small" />
                                                                </IconButton>
                                                              </div>
                                                            </div>
                                                          </li>
                                                        )}
                                                      </Draggable>
                                                    )
                                                  )}
                                                  {provided.placeholder}
                                                </ul>
                                              )}
                                            </Droppable>
                                          </DragDropContext>

                                          <div
                                            style={{
                                              opacity: subOpenAdd[index]?.open ? 1 : 0,
                                              height: subOpenAdd[index]?.open ? 95 : 0,
                                              marginBottom: subOpenAdd[index]?.open ? 10 : 0,
                                              visibility: subOpenAdd[index]?.open
                                                ? "visible"
                                                : "hidden",
                                              transition: "0.3s",
                                              display: "flex",
                                              alignItems: "center",
                                              flexDirection: "column",
                                              gap: 10,
                                              width: "90%",
                                              paddingTop: 5,
                                            }}>
                                            <TextField
                                              sx={{ width: "90%" }}
                                              label="Tilte"
                                              variant="outlined"
                                              size="small"
                                              value={subInputV[index]?.title || ""}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map((item, idx) => {
                                                    if (idx === index) {
                                                      return {
                                                        ...item,
                                                        title: e.target.value,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }),
                                                ]);
                                              }}
                                            />
                                            <TextField
                                              sx={{ width: "90%" }}
                                              label="Description"
                                              variant="outlined"
                                              size="small"
                                              value={subInputV[index]?.description || ""}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map((item, idx) => {
                                                    if (idx === index) {
                                                      return {
                                                        ...item,
                                                        description: e.target.value,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }),
                                                ]);
                                              }}
                                            />
                                          </div>
                                          <div
                                            onClick={() => {
                                              if (subOpenAdd[index]?.open == false) {
                                                setSubOpenAdd([
                                                  ...subOpenAdd.map((item, idx) => {
                                                    if (idx === index) {
                                                      return {
                                                        ...item,
                                                        open: true,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }),
                                                ]);
                                              } else {
                                                if (
                                                  subInputV[index]?.title !== "" &&
                                                  subInputV[index]?.description !== ""
                                                ) {
                                                  addNewSubMenuItem(index, idx);
                                                } else {
                                                  setSubOpenAdd([
                                                    ...subOpenAdd.map((item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          open: false,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }),
                                                  ]);
                                                }
                                              }
                                            }}
                                            className="submitBTN"
                                            style={{
                                              gap: 7,
                                              fontSize: 15,
                                              height: 40,
                                              marginTop: 0,
                                              backgroundColor: subOpenAdd[index]?.open
                                                ? subInputV[index]?.title == "" ||
                                                  subInputV[index]?.description == ""
                                                  ? "red"
                                                  : "var(--link)"
                                                : "var(--link)",
                                            }}>
                                            {subOpenAdd[index]?.open
                                              ? subInputV[index]?.title == "" ||
                                                subInputV[index]?.description == ""
                                                ? "Cancel"
                                                : "Submit"
                                              : "Add New"}
                                            {subOpenAdd[index]?.open ? (
                                              ""
                                            ) : (
                                              <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                                            )}
                                          </div>
                                          <div
                                            style={{
                                              height: 32,
                                              width: "60%",
                                              marginTop: 2,
                                            }}
                                            className="cancelBTN"
                                            onClick={() => {
                                              setOpenSubMenuIdx(null);
                                              setSubItemEditible({});
                                            }}>
                                            Close
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <div
                      style={{
                        opacity: openAdd[index]?.open ? 1 : 0,
                        maxHeight: openAdd[index]?.open ? 2000 : 0,
                        marginBottom: openAdd[index]?.open ? 10 : 0,
                        visibility: openAdd[index]?.open ? "visible" : "hidden",
                        transition: "0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        marginTop: 15,
                        height: "auto",
                      }}>
                      <TextField
                        sx={{ width: "35%" }}
                        label="Account Type"
                        variant="outlined"
                        value={inputV[index]?.title || ""}
                        onChange={(e) => handleInputChange(index, "title", e.target.value)}
                      />
                      <div>
                        <TextField
                          sx={{ width: "35%", mr: 1 }}
                          label="Button One Text"
                          variant="outlined"
                          size="small"
                          value={inputV[index]?.btn1T || ""}
                          onChange={(e) => handleInputChange(index, "btn1T", e.target.value)}
                        />
                        <TextField
                          sx={{ width: "35%" }}
                          label="Button One Link"
                          variant="outlined"
                          size="small"
                          value={inputV[index]?.btn1L || ""}
                          onChange={(e) => handleInputChange(index, "btn1L", e.target.value)}
                        />
                      </div>

                      <div>
                        <TextField
                          sx={{ width: "35%", mr: 1 }}
                          label="Button Two Text"
                          variant="outlined"
                          size="small"
                          value={inputV[index]?.btn2T || ""}
                          onChange={(e) => handleInputChange(index, "btn2T", e.target.value)}
                        />
                        <TextField
                          sx={{ width: "35%" }}
                          label="Button Two Link"
                          variant="outlined"
                          size="small"
                          value={inputV[index]?.btn2L || ""}
                          onChange={(e) => handleInputChange(index, "btn2L", e.target.value)}
                        />
                      </div>

                      <div>
                        <TextEditor
                          value={inputV[index]?.desc || ""}
                          onChange={(v) => handleInputChange(index, "desc", v)}
                        />
                      </div>
                    </div>
                    {Object.keys(itemEditible).length > 0 ? (
                      <div className="submitBTN" onClick={() => updateItem(index)}>
                        Update Item
                      </div>
                    ) : (
                      <>
                        <div
                          className="submitBTN"
                          style={{
                            display: user.perms[7].edit ? null : "none",
                            width: "35%",
                            fontSize: 15,
                            height: 40,
                            gap: 7,
                            borderRadius: 7,
                            marginTop: 10,
                            backgroundColor: openAdd[index]?.open
                              ? inputV[index]?.title == "" ||
                                inputV[index]?.desc == "p" ||
                                inputV[index]?.btn1T == "" ||
                                inputV[index]?.btn1L == "" ||
                                inputV[index]?.btn2T == "" ||
                                inputV[index]?.btn2L == ""
                                ? "red"
                                : "var(--link)"
                              : "var(--link)",
                          }}
                          onClick={() => {
                            if (openAdd[index]?.open == false) {
                              setOpenAdd([
                                ...openAdd.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, open: true };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            } else {
                              if (
                                inputV[index]?.title !== "" &&
                                inputV[index]?.desc !== "" &&
                                inputV[index]?.btn1T !== "" &&
                                inputV[index]?.btn1L !== "" &&
                                inputV[index]?.btn2T !== "" &&
                                inputV[index]?.btn2L !== ""
                              ) {
                                addNewMenuItem(index);
                              } else {
                                setOpenAdd([
                                  ...openAdd.map((item, idx) => {
                                    if (idx === index) {
                                      return { ...item, open: false };
                                    } else {
                                      return item;
                                    }
                                  }),
                                ]);
                              }
                            }
                          }}>
                          {openAdd[index]?.open
                            ? inputV[index]?.title == "" ||
                              inputV[index]?.desc == "" ||
                              inputV[index]?.btn1T == "" ||
                              inputV[index]?.btn1L == "" ||
                              inputV[index]?.btn2T == "" ||
                              inputV[index]?.btn2L == ""
                              ? "Cancel"
                              : "Submit"
                            : "Add New"}
                          {openAdd[index]?.open ? (
                            ""
                          ) : (
                            <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                          )}
                        </div>
                        {user.perms[7].edit && (
                          <div className="submitBTN" onClick={() => submitData(item, index)}>
                            Save Changes
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {Object.keys(itemEditible).length > 0 ||
                    Object.keys(subItemEditible).length > 0 ? (
                    <div
                      className="flex items-center content-center w-[350px] h-10 bg-red-500  mt-3 text-white rounded-md cursor-pointer hover:bg-red-600"
                      onClick={() => {
                        setItemEditible({});
                        setSubItemEditible({});
                        setOpenAdd([
                          ...openAdd.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                open: false,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);

                        const clearedInputV = inputV.map((item) => ({
                          title: "",
                          btn1T: "",
                          btn1L: "",
                          btn2T: "",
                          btn2L: "",
                          desc: "",
                        }));

                        setInputV(clearedInputV);
                      }}>
                      Cancel Editing
                    </div>
                  ) : null}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
